import Joi from '@hapi/joi'

export const TeaWorkerDeploymentDetailsSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select estate`,
        "any.required": `Estate required`
    }),
    month: Joi.string().required().label("Month").messages({
        "any.invalid": `Select Month`,
        "any.required": `Month required`
    }),
}

